import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { UpdateWatiConfigInput } from '@pms/shared';
import { messageService } from '@/services/message.service';
import { getErrorMessage } from '@/lib/errors';

const KEY = ['messages', 'config'] as const;

/** One concern: read + save the miss-punch reminder settings, for either provider. */
export function useMessageConfig() {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: KEY,
    queryFn: () => messageService.getConfig(),
  });

  const mutation = useMutation({
    mutationFn: (patch: UpdateWatiConfigInput) => messageService.updateConfig(patch),
    onSuccess: () => {
      toast.success('Message settings saved');
      void queryClient.invalidateQueries({ queryKey: KEY });
    },
    onError: (e) => toast.error(getErrorMessage(e)),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => void query.refetch(),
    save: mutation.mutate,
    saving: mutation.isPending,
  };
}
